import { format } from '@office-start/string-formatter-utility';
import { StoreHeadlessDialogUrl } from '../constants';
/**
 * Format the URL for the About, Install, or Upgrade dialog with appId and locale information
 * @param appId Id of the app whose 'about/install' information is displayed
 * @returns Promise<string>
 */
export var getDialogURL = function (context, appId) {
    return format(StoreHeadlessDialogUrl, appId, context.preferredCulture);
};
//# sourceMappingURL=getDialogURL.js.map